var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"form-block pa-10"},[_c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-4"},[_vm._v("Zenmoney")]),_c('v-btn',{staticClass:"mt-12",attrs:{"color":"main white--text"},on:{"click":_vm.goToZenmoney}},[_vm._v("Перейти на сайт Zenmoney")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }